"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPerimeterXError = exports.renderPerimeterXCaptcha = exports.errorToJson = void 0;
/* eslint-disable @typescript-eslint/no-unsafe-call */
// browser-monads isn't typed
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
const browser_monads_1 = require("browser-monads");
const fluture_1 = require("fluture");
const contains_1 = __importDefault(require("ramda/src/contains"));
const nth_1 = __importDefault(require("ramda/src/nth"));
const split_1 = __importDefault(require("ramda/src/split"));
const ts_functional_pipe_1 = require("ts-functional-pipe");
const ts_pattern_1 = require("ts-pattern");
const constants_1 = require("../constants");
const style_1 = __importDefault(require("./style"));
/**
 * Extracts an object from the middle of an error message and turns it back into valid JSON.
 *
 * Takes in an error like this `Error('403: { key: value } - https://url.com')`
 * and returns an object like this `{ key: value }`
 *
 * @package This is an internal function.
 */
const errorToJson = (err) => 
// The error message contains the body of the failed request, which we need to parse into JSON.
(0, ts_functional_pipe_1.pipeInto)(err.message, (0, split_1.default)(/{(.*)/), // split at the first {
(x) => (0, nth_1.default)(1, x) || '', // get index 1
(0, split_1.default)(/}(.*)/), // split at the closing }
(x) => (0, nth_1.default)(0, x) || '', // get index 0
// get index 0
x => `{${x}}`, // wrap up the values in {}
JSON.parse // parse it
);
exports.errorToJson = errorToJson;
const perimeterXElementId = 'px-captcha';
const isPerimeterXCaptchaPresent = () => !!browser_monads_1.document.getElementById(perimeterXElementId);
const humanChallengeConfig = {
    challenge: {
        translation: { 'default': { btn: 'Press & Hold', }, },
        view: {
            backgroundColor: '#FFFFFF',
            borderColor: '#1774E2',
            borderRadius: 10,
            borderWidth: 2,
            css: ['https://simplisafe.com/fonts.css'],
            fillColor: '#D3D3D3',
            fontWeight: 500,
            height: '62px',
            // margin: '32px auto 24px auto',
            texSize: 22,
            textColor: '#1774E2',
            textFont: 'SimpliSans',
            width: '296px'
        }
    }
};
/**
 * If an API response contains perimeterX details, this function will inject the captcha into the page.
 *
 * @package This is an interal function.
 */
const renderPerimeterXCaptcha = (err) => {
    const pxValues = (0, exports.errorToJson)(err);
    browser_monads_1.window._pxAppId = pxValues.appId;
    browser_monads_1.window._pxJsClientSrc = pxValues.jsClientSrc;
    browser_monads_1.window._pxFirstPartyEnabled = pxValues.firstPartyEnabled;
    browser_monads_1.window._pxUuid = pxValues.uuid;
    browser_monads_1.window._pxHostUrl = pxValues.hostUrl;
    browser_monads_1.window._pxOnCaptchaSuccess = (isValid) => isValid
        ? browser_monads_1.document.location.reload()
        // eslint-disable-next-line no-console
        : console.info('PerimeterX captcha was non-valid');
    browser_monads_1.window['_' + browser_monads_1.window._pxAppId] = humanChallengeConfig;
    // Create and append the px div into the body
    // Design for page https://app.zeplin.io/project/624345e1780db51ea66833cd/screen/62e81f80005a721314797ae8
    // eslint-disable-next-line functional/immutable-data
    browser_monads_1.document.body.innerHTML = `
       <div style="width: 100vw;">
         <div class="Header">
         <img src="https://images.ctfassets.net/br4ichkdqihc/7k7wnuCFM9OHVL1XvVqelk/15106bc63aa38e9d15c321ec181fa74c/SimpliSafe-wordmark-RGB_2x.png?w=332&h=76&q=50&fm=webp&fit=fill" 
              alt="SimpliSafe"
              class="SS-Logo"
              >
         </div>
         <div class="Captcha-container">
           <h1 class="Pardon-the-interrupt">Pardon the interruption...</h1>
           <p class="We-know-youre-proba">We know you're probably not a bot, but better safe than sorry. Please take 2 seconds to confirm that you're a real person.</p>
           <div id="${perimeterXElementId}"></div>
           <p class="Why-am-I-seeing-this"> <span class="text-style-1">Why am I seeing this?</span> <br> You may be getting this message if JavaScript or cookies are disabled.<br> Occasionally a plugin or extension may be at fault. <br> <a class="text-style-2" href="https://www.perimeterx.com/whywasiblocked/#">Learn more</a> </p>
         </div>
       </div>`;
    // eslint-disable-next-line functional/immutable-data
    const styleSheet = browser_monads_1.document.createElement('style');
    // eslint-disable-next-line functional/immutable-data
    browser_monads_1.document.head.appendChild(styleSheet);
    // eslint-disable-next-line functional/immutable-data
    styleSheet.type = 'text/css';
    // eslint-disable-next-line functional/no-conditional-statement
    if (styleSheet.styleSheet) {
        // This is required for IE8 and below.
        // eslint-disable-next-line functional/immutable-data
        styleSheet.styleSheet.cssText = style_1.default;
    }
    else {
        // eslint-disable-next-line functional/immutable-data
        styleSheet.appendChild(browser_monads_1.document.createTextNode(style_1.default));
    }
    // Create and append the clientSrc into the header
    const clientSrc = browser_monads_1.document.createElement('script');
    // eslint-disable-next-line functional/immutable-data
    clientSrc.src = `https:${pxValues.jsClientSrc}`;
    browser_monads_1.document.head.appendChild(clientSrc);
    // Create and append the blockScript into the header
    const blockScript = browser_monads_1.document.createElement('script');
    // eslint-disable-next-line functional/immutable-data
    blockScript.src = `https:${pxValues.blockScript}`;
    browser_monads_1.document.head.appendChild(blockScript);
};
exports.renderPerimeterXCaptcha = renderPerimeterXCaptcha;
const isPerimeterXError = (error) => (0, contains_1.default)('perimeterx', error.message);
exports.isPerimeterXError = isPerimeterXError;
/**
 * Handles showing the PerimeterX captcha from API responses
 * @package This is an interal function.
 */
const handlePerimeterX = (error) => (0, ts_pattern_1.match)(error)
    /** If the error message contains `perimeterx` we know we need to show the captcha */
    .when(exports.isPerimeterXError, e => {
    (0, constants_1.isPxCaptchaEnabled)() && !isPerimeterXCaptchaPresent() && (0, exports.renderPerimeterXCaptcha)(e);
    return (0, fluture_1.reject)(e);
})
    /** If non of the above conditions are met we just reject with the original error */
    .otherwise(() => (0, fluture_1.reject)(error));
exports.default = handlePerimeterX;
//# sourceMappingURL=index.js.map